import { z } from "zod";

const meetingQuestion = z.object({
  questionId: z.string(),
  questionText: z.string(),
  questionCode: z.string().nullable(),
  isRequired: z.boolean(),
  limitedToChoices: z.array(z.string()).nullable(),
});

export enum MeetingTypeCode {
  physical = "physical",
  digital = "digital",
}

export const meetingTypeCode = z.enum(MeetingTypeCode);

const meetingType = z.object({
  meetingTypeId: z.string(),
  meetingTypeCode: meetingTypeCode,
  meetingTypeName: z.string(),
  additionalInformation: z.string(),
  questions: z.array(meetingQuestion),
});

export type MeetingType = z.infer<typeof meetingType>;

export const bookingMeetingTypes = z.object({
  meetingTypes: z.array(meetingType),
});

export type BookingMeetingTypes = z.infer<typeof bookingMeetingTypes>;
